import { ScrewDataType } from "../../interface/dataTypeInterface";

export const screwData: ScrewDataType[] = [
  {
    id: "screws_metric_thread_rough_ss_2",
    name: "Screws, metric thread rough pitch (SS2)",
    updatedAt: "2022-09-23",
    // descriptions: ["", "more information"],
    data: [
      {
        type: { value: "M2" },
        pitch: { value: "0,4", unit: "mm" },
        mean_diameter: { value: "1,740", unit: "mm" },
        inner_diameter: { value: "1,567", unit: "mm" },
      },
      {
        type: { value: "M2,5" },
        pitch: { value: "0,45", unit: "mm" },
        mean_diameter: { value: "2,208", unit: "mm" },
        inner_diameter: { value: "2,013", unit: "mm" },
      },
      {
        type: { value: "M3" },
        pitch: { value: "0,5", unit: "mm" },
        mean_diameter: { value: "2,675", unit: "mm" },
        inner_diameter: { value: "2,459", unit: "mm" },
      },
      {
        type: { value: "M4" },
        pitch: { value: "0,7", unit: "mm" },
        mean_diameter: { value: "3,545", unit: "mm" },
        inner_diameter: { value: "3,242", unit: "mm" },
      },
      {
        type: { value: "M5" },
        pitch: { value: "0,8", unit: "mm" },
        mean_diameter: { value: "4,480", unit: "mm" },
        inner_diameter: { value: "4,134", unit: "mm" },
      },
      {
        type: { value: "M6" },
        pitch: { value: "1", unit: "mm" },
        mean_diameter: { value: "5,350", unit: "mm" },
        inner_diameter: { value: "4,917", unit: "mm" },
      },
      {
        type: { value: "M8" },
        pitch: { value: "1,25", unit: "mm" },
        mean_diameter: { value: "7,188", unit: "mm" },
        inner_diameter: { value: "6,647", unit: "mm" },
      },
      {
        type: { value: "M10" },
        pitch: { value: "1,5", unit: "mm" },
        mean_diameter: { value: "9,026", unit: "mm" },
        inner_diameter: { value: "8,376", unit: "mm" },
      },
      {
        type: { value: "M12" },
        pitch: { value: "1,75", unit: "mm" },
        mean_diameter: { value: "10,863", unit: "mm" },
        inner_diameter: { value: "10,106", unit: "mm" },
      },
      {
        type: { value: "M14" },
        pitch: { value: "2", unit: "mm" },
        mean_diameter: { value: "12,701", unit: "mm" },
        inner_diameter: { value: "11,835", unit: "mm" },
      },
      {
        type: { value: "M16" },
        pitch: { value: "2", unit: "mm" },
        mean_diameter: { value: "14,701", unit: "mm" },
        inner_diameter: { value: "13,835", unit: "mm" },
      },
      {
        type: { value: "M20" },
        pitch: { value: "2,5", unit: "mm" },
        mean_diameter: { value: "18,376", unit: "mm" },
        inner_diameter: { value: "17,294", unit: "mm" },
      },
      {
        type: { value: "M24" },
        pitch: { value: "3", unit: "mm" },
        mean_diameter: { value: "22,051", unit: "mm" },
        inner_diameter: { value: "20,752", unit: "mm" },
      },
      {
        type: { value: "M30" },
        pitch: { value: "3,5", unit: "mm" },
        mean_diameter: { value: "27,727", unit: "mm" },
        inner_diameter: { value: "26,211", unit: "mm" },
      },
      {
        type: { value: "M36" },
        pitch: { value: "4", unit: "mm" },
        mean_diameter: { value: "33,402", unit: "mm" },
        inner_diameter: { value: "31,670", unit: "mm" },
      },
      {
        type: { value: "M42" },
        pitch: { value: "4,5", unit: "mm" },
        mean_diameter: { value: "39,077", unit: "mm" },
        inner_diameter: { value: "37,129", unit: "mm" },
      },
      {
        type: { value: "M48" },
        pitch: { value: "5", unit: "mm" },
        mean_diameter: { value: "44,752", unit: "mm" },
        inner_diameter: { value: "42,587", unit: "mm" },
      },
      {
        type: { value: "M56" },
        pitch: { value: "5,5", unit: "mm" },
        mean_diameter: { value: "52,428", unit: "mm" },
        inner_diameter: { value: "50,046", unit: "mm" },
      },
      {
        type: { value: "M64" },
        pitch: { value: "6", unit: "mm" },
        mean_diameter: { value: "60,103", unit: "mm" },
        inner_diameter: { value: "57,505", unit: "mm" },
      },
    ],
  },
  {
    id: "hex_socket_head_din_912",
    name: "hex socket head (DIN 912)",
    updatedAt: "2022-09-23",
    // descriptions: ["screw information", "more information"],
    data: [
      {
        type: { value: "M2,5" },
        screw_head_diameter: { value: "4,5", unit: "mm" },
        screw_head_height: { value: "2,5", unit: "mm" },
      },
      {
        type: { value: "M3" },
        screw_head_diameter: { value: "5,5", unit: "mm" },
        screw_head_height: { value: "3", unit: "mm" },
      },
      {
        type: { value: "M4" },
        screw_head_diameter: { value: "7", unit: "mm" },
        screw_head_height: { value: "4", unit: "mm" },
      },
      {
        type: { value: "M5" },
        screw_head_diameter: { value: "8,5", unit: "mm" },
        screw_head_height: { value: "5", unit: "mm" },
      },
      {
        type: { value: "M6" },
        screw_head_diameter: { value: "10", unit: "mm" },
        screw_head_height: { value: "6", unit: "mm" },
      },
      {
        type: { value: "M8" },
        screw_head_diameter: { value: "15", unit: "mm" },
        screw_head_height: { value: "8", unit: "mm" },
      },
      {
        type: { value: "M10" },
        screw_head_diameter: { value: "18", unit: "mm" },
        screw_head_height: { value: "10", unit: "mm" },
      },
      {
        type: { value: "M12" },
        screw_head_diameter: { value: "18", unit: "mm" },
        screw_head_height: { value: "12", unit: "mm" },
      },
      {
        type: { value: "M14" },
        screw_head_diameter: { value: "21", unit: "mm" },
        screw_head_height: { value: "14", unit: "mm" },
      },
      {
        type: { value: "M16" },
        screw_head_diameter: { value: "24", unit: "mm" },
        screw_head_height: { value: "16", unit: "mm" },
      },
      {
        type: { value: "M20" },
        screw_head_diameter: { value: "30", unit: "mm" },
        screw_head_height: { value: "20", unit: "mm" },
      },
      {
        type: { value: "M24" },
        screw_head_diameter: { value: "36", unit: "mm" },
        screw_head_height: { value: "24", unit: "mm" },
      },
      {
        type: { value: "M30" },
        screw_head_diameter: { value: "46", unit: "mm" },
        screw_head_height: { value: "18,7", unit: "mm" },
      },
    ],
  },
  {
    id: "hex_head_screw_din_931",
    name: "hex head screw (DIN 931)",
    updatedAt: "2022-09-23",
    // descriptions: ["screw information", "more information"],
    data: [
      {
        type: { value: "M3" },
        screw_head_diameter: { value: "5,5", unit: "mm" },
        screw_head_height: { value: "2", unit: "mm" },
      },
      {
        type: { value: "M4" },
        screw_head_diameter: { value: "7", unit: "mm" },
        screw_head_height: { value: "2,8", unit: "mm" },
      },
      {
        type: { value: "M5" },
        screw_head_diameter: { value: "8", unit: "mm" },
        screw_head_height: { value: "3,5", unit: "mm" },
      },
      {
        type: { value: "M6" },
        screw_head_diameter: { value: "10", unit: "mm" },
        screw_head_height: { value: "4", unit: "mm" },
      },
      {
        type: { value: "M8" },
        screw_head_diameter: { value: "13", unit: "mm" },
        screw_head_height: { value: "5,3", unit: "mm" },
      },
      {
        type: { value: "M10" },
        screw_head_diameter: { value: "16", unit: "mm" },
        screw_head_height: { value: "6,4", unit: "mm" },
      },
      {
        type: { value: "M12" },
        screw_head_diameter: { value: "18", unit: "mm" },
        screw_head_height: { value: "7,5", unit: "mm" },
      },
      {
        type: { value: "M14" },
        screw_head_diameter: { value: "21", unit: "mm" },
        screw_head_height: { value: "8,8", unit: "mm" },
      },
      {
        type: { value: "M16" },
        screw_head_diameter: { value: "24", unit: "mm" },
        screw_head_height: { value: "10", unit: "mm" },
      },
      {
        type: { value: "M20" },
        screw_head_diameter: { value: "30", unit: "mm" },
        screw_head_height: { value: "12,5", unit: "mm" },
      },
      {
        type: { value: "M24" },
        screw_head_diameter: { value: "36", unit: "mm" },
        screw_head_height: { value: "15", unit: "mm" },
      },
      {
        type: { value: "M30" },
        screw_head_diameter: { value: "46", unit: "mm" },
        screw_head_height: { value: "18,7", unit: "mm" },
      },
    ],
  },
];
